import { ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Helper } from "../../core/util/helper";
import { Grid } from "../../../app/core/components/grid";
import { Dialog } from "../../../app/core/components/dialog";
import { EmailTemplateContext, EmailTemplateEntity } from "./template";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { BaseComponentProps } from "../../core/components/baseComponentProps";
import React from "react";

export default class StaticDocs extends React.Component<StaticDocsProps, StaticDocsState> {
    private gridOptions: kendo.ui.GridOptions;

    private gridId = kendo.guid();

    constructor(props: StaticDocsProps) {
        super(props)
        this.state = {
            gridData: []
        };
        this.initApp();
    }

    private setValue = (items: GridItem[], isInit = false) => {
        const distinct = (value: GridItem, index: number, self: GridItem[]) => {
            return self.findIndex(f => f.Id === value.Id) === index;
        };
        const orderByAlphabet = (a: GridItem, b: GridItem) => {
            if (a.Title < b.Title) {
                return -1;
            }
            if (a.Title > b.Title) {
                return 1;
            }
            return 0;
        }
        items = items.filter(distinct).sort(orderByAlphabet);
        this.setState({ gridData: items }, () => {
            if (!isInit) {
                const ids = items.map((item) => { return item.Id })
                this.props.onChange(this.props.field, ids);
            }
        })
    }

    private loadDocuments = async (isInit = false) => {
        const result = await HTTPService.post<JsonResultClass<GridItem[]>>("EmailSender/GetDocuments", { ids: this.props.value });
        if (result.Code == 0) {
            this.setValue(result.Data, isInit);
        }
    }

    private initApp = () => {
        this.initGridOptions();
        this.loadDocuments(true);
    }

    private initGridOptions = () => {
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            editable: false,
            columns: [
                {
                    field: "Title",
                    title: this.props.context.translations["Field.Dokument.titel"]
                }
            ]
        };
    }

    private renderGrid = () => {
        const standardButtons = [
            {
                type: ToolBarStandardButtonType.NEW,
                caption: Config.translations.newLabel,
                enabled: true
            },
            {
                type: ToolBarStandardButtonType.DELETE,
                caption: Config.translations.deleteLabel,
                enabled: true
            }
        ];

        return (
            <div className="flex-container" id={this.gridId}>
                <Grid
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="staticDocs"
                    standardButtons={standardButtons}
                    onClickStandardButton={this.handleClickStandardButton}
                />
            </div>
        );
    }


    private handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: GridItem) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                this.addDocument();
                break;
            case ToolBarStandardButtonType.DELETE:
                const gridData = this.state.gridData.filter(f => f.Id !== dataItem.Id);;
                this.setValue(gridData);
                break;
        }
    }


    private addDocument = () => {
        const sheet = General.Sheet.Manager.createSheetWithUrl(`DynamicSearch/Window/documents?multi=true&displayPattern=[[title]]&cus_noUrl=1&fullObject=true&cus_usedDocs=${JSON.stringify(this.state.gridData.map((item) => { return item.Id }))}`);
        sheet.bind(SheetEventType.ItemsSelected, async (ev) => {
            let docs = ev.data.map(x => (
                {
                    Id: x.isguid, 
                    Title: x.title
                }
            ));
            const gridData = this.state.gridData;
            gridData.push(...docs);
            this.setValue(gridData);
        });
    }

    render() {
        return Helper.hasValue(this.gridOptions) ? this.renderGrid() : null;
    }
}

interface StaticDocsProps extends BaseComponentProps {
    value: string[];
    onChange: (field, value: string[]) => void;
    entity: EmailTemplateEntity;
    context: EmailTemplateContext;
}

interface StaticDocsState {
    gridData: GridItem[];
}

interface GridItem {
    Id: string;
    Title: string;
}